export class Profile {
    uuid_passenger?: string;
    uuid_employee?: string;
    displayName: string;
    badgeNumber: string | null;
    canReserveOccurrence: boolean;
    canAccessEvent: boolean;
    selected: boolean;
    selectable: boolean;
    inizialiNome: string;

    constructor(
        name: string,
        badge: string | null,
        canReserveOccurrence: boolean,
        canAccessEvent: boolean,
        uuid_passenger?: string,
        uuid_employee?: string,
    ) {
        this.uuid_passenger = uuid_passenger;
        this.uuid_employee = uuid_employee;
        this.displayName = name;
        this.badgeNumber = badge;
        this.canReserveOccurrence = canReserveOccurrence;
        this.canAccessEvent = canAccessEvent;
        this.selected = false;
        this.selectable = canReserveOccurrence && canAccessEvent;
    }
}